import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OptionsTableHeader = ({
  showDrag = true,
  showPreselect = true,
  showInternalValue = true
}) => /*#__PURE__*/_jsx("thead", {
  "data-test-id": "options-table-header",
  children: /*#__PURE__*/_jsxs("tr", {
    children: [showDrag && /*#__PURE__*/_jsx("th", {
      children: showPreselect && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "options.preselectLabel"
      })
    }), !showPreselect ? /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "options.label"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), showInternalValue && /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "options.internalValue"
      })
    }), /*#__PURE__*/_jsx("th", {})]
  })
});
export default OptionsTableHeader;